export default __webpack_public_path__ + "static/home-background-sm-995d58b34b71f6ad8d96daa4b9755d3f.jpg";